import { GraphQLClient } from 'graphql-request';

import { QueryClient } from '@tanstack/react-query';

import { API_URL } from '~src/config';

export { QueryClientProvider, useQuery, useQueryClient } from '@tanstack/react-query';

const GRAPHQL_URL = `${API_URL}/graphql/v1`;

export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1 } },
});

export const graphQLClient = new GraphQLClient(GRAPHQL_URL, {
  keepalive: true,
});
